module.exports = require("@nestjs-modules/mailer");